// Per REV-106: gender derived from the last letter of the first name.
// Polish convention — names ending in "a" are typically female. Anything else is ambiguous
// (typos, initials, foreign names, exceptions) so we report null rather than guess "male"
// and skew analytics with confident-but-wrong values.
export const guessGenderFromFirstName = (firstName: string | undefined | null): "female" | "male" | null => {
  if (!firstName) return null;
  const trimmed = firstName.trim();
  if (!trimmed) return null;
  return trimmed.slice(-1).toLowerCase() === "a" ? "female" : null;
};
